import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { GetCumulativeBookingsDto } from '../../../models/analytics/dto/get-cumulative-bookings.dto';
import { AnalyticsFilterParams, buildFilterSuffix } from './analyticsFilterParams';

export const GET_CUMULATIVE_BOOKINGS_QUERY_KEY = 'getCumulativeBookings';

export const useGetCumulativeBookings = (locationId: string, startDate?: Date, endDate?: Date, filters?: AnalyticsFilterParams) => {
    const apiClient = useApiClient();
    return useQuery({
        queryKey: [GET_CUMULATIVE_BOOKINGS_QUERY_KEY, locationId, startDate?.getTime(), endDate?.getTime(), filters?.courtIds, filters?.sportTypes],
        queryFn: async () => {
            let url = `analytics/cumulative-bookings?locationId=${locationId}`;
            if (startDate && endDate) {
                url += `&startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`;
            }
            url += buildFilterSuffix(filters);
            const response = await apiClient.fetchApi<GetCumulativeBookingsDto, {}>({ method: 'GET', endpoint: url });
            return response;
        },
        enabled: !!locationId,
        staleTime: 5 * 60 * 1000,
    });
};
